import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';

import { FieldEnum, ReportFieldEnum } from 'Common/FieldEnum';
import { SiteComponent } from 'Common/SiteComponent';
import { TitledCard } from 'Components';
import { SPECIAL_MESSAGE_FORM_NAME } from 'Common/FormEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { SortByOptions } from '../constants';
import { ReportFormatButtonGroup } from 'Components/forms/ReportFormatButtonGroup';


class SpecialMessageForm extends Component {
  render() {
    const { dispatch, formValues } = this.props;

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={6}>
                <SiteComponent
                  name={FieldEnum.SiteId}
                  isForm={true}
                  {...this.props}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <div className="ui form field">
                  <label>Sort By</label>
                </div>
                <ReduxFormButtonGroup
                  dispatch={dispatch}
                  formName={SPECIAL_MESSAGE_FORM_NAME}
                  fieldName={FieldEnum.SortBy}
                  options={SortByOptions}
                  value={formValues[FieldEnum.SortBy]}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <ReportFormatButtonGroup
                  formName={SPECIAL_MESSAGE_FORM_NAME}
                  fieldName={ReportFieldEnum.ReportFormat}
                  label="Report Format"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values[FieldEnum.SiteId]) {
    errors[FieldEnum.SiteId] = 'Site is required';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: SPECIAL_MESSAGE_FORM_NAME,
  destroyOnUnmount: false,
})(SpecialMessageForm);



// WEBPACK FOOTER //
// ./src/pages/specialmessage/components/SpecialMessageForm.js